export const setLocalstorageValue = (label: string, value: string) => {
  sessionStorage.setItem(label, value.toString());
};

export const getLocalstorageValue = (label: string): string => {
  return (sessionStorage.getItem(label) as string) || "0";
};
